import type { GenericPipeItem, GenericSchema } from 'valibot'
import type { NormalizedComponents } from '~/utils/crystallize/component-utils'
import { array, literal, nullish, object, pipe, transform } from 'valibot'
import { baseCatalogueSchema } from '~/utils/crystallize/catalogue'
import {
  components,
  relatedDocument,
  richTextData,
  singleLineData,
} from '~/utils/crystallize/component-schemas'

export function crystallizeDefaultFolderSchema<TChildSchema extends GenericSchema>(childSchema: TChildSchema) {
  return crystallizeFolderSchema(
    'default-folder',
    childSchema,
    object({
      title: nullish(singleLineData),
      description: nullish(richTextData),
      links: nullish(
        array(
          object({
            label: singleLineData,
            url: singleLineData,
          }),
        ),
      ),
      highlighted: pipe(
        safeArray(relatedDocument),
        transform(it => it[0]),
      ),
    }),
  )
}

export function crystallizeFolderSchema<
  const TShape extends string,
  TChildSchema extends GenericSchema,
  TOutput,
  TComponentsSchema extends GenericPipeItem<NormalizedComponents, TOutput>,
>(
  shape: TShape,
  childSchema: TChildSchema,
  componentsSchema: TComponentsSchema,
) {
  return object({
    ...baseCatalogueSchema.entries,
    type: literal('folder'),
    shape: object({
      identifier: literal(shape),
    }),
    children: safeArray(childSchema),
    components: components(componentsSchema),
  })
}
